import React, { memo } from 'react';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import {
  ensureListing,
  getListingMonthlyFlexPrice,
  getListingMonthlyPrice,
  listingIsLongTermRental,
} from '../../util/data';
import css from './ListingCardV2.css';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';
import { FormattedMessage, injectIntl } from 'react-intl';
import NamedLink from '../NamedLink/NamedLink';
import { createSlug } from '../../util/urlHelpers';
import config from '../../config';
import { formatHourlyMoney, formatMoney } from '../../util/currency';
import IconReviewStar from '../IconReviewStar/IconReviewStar';
import flexCarLogo from '../../assets/flexCarLogo.png';
import { pick } from 'lodash';

const DrivelahGoLogo = () => {
  return (
    <span className={css.logo}>
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="26" viewBox="0 0 60 26">
        <g id="Group_195" data-name="Group 195" transform="translate(-41 -302)">
          <rect
            id="Rectangle_2"
            data-name="Rectangle 2"
            width="60"
            height="26"
            rx="5"
            transform="translate(41 302)"
            fill="#00a3ad"
          />
          <g id="Group_168" data-name="Group 168" transform="translate(48 307.872)">
            <g id="Group_167" data-name="Group 167" transform="translate(2 0)">
              <g id="Group_166" data-name="Group 166" transform="translate(0 0)">
                <g id="Group_165" data-name="Group 165">
                  <g id="Group_164" data-name="Group 164">
                    <path
                      id="Path_39"
                      data-name="Path 39"
                      d="M21.506,5.73a6.542,6.542,0,0,0-4.779-2.674c-.363-.053-.558-.1-.613-.173a10.536,10.536,0,0,0-.965-1.189A5.042,5.042,0,0,0,11.94.114,15.919,15.919,0,0,0,8.456.078a8.454,8.454,0,0,0-4.688,1.89A8.742,8.742,0,0,0,1.642,4.582a9.4,9.4,0,0,0-.473,1.05c-.06.15-.111.282-.158.377C1,6.021.98,6.033.971,6.041a2.064,2.064,0,0,0-.647.748,5.6,5.6,0,0,0-.319,1.8,2.6,2.6,0,0,0,.55,2.134l.039.034.044.026a4.41,4.41,0,0,0,2.111.5c.158,0,.324-.008.5-.024l.506-.05A3.259,3.259,0,0,1,3.444,10l-.321.032a3.5,3.5,0,0,1-1.8-.277,2.659,2.659,0,0,1-.1-1.121,4.759,4.759,0,0,1,.189-1.294.883.883,0,0,1,.3-.327,1.154,1.154,0,0,0,.352-.379,5.166,5.166,0,0,0,.242-.555,8.266,8.266,0,0,1,.41-.916A7.639,7.639,0,0,1,4.578,2.891,7.207,7.207,0,0,1,8.587,1.3a14.5,14.5,0,0,1,3.218.034,3.843,3.843,0,0,1,2.449,1.2,9.541,9.541,0,0,1,.858,1.058,1.906,1.906,0,0,0,1.439.679,5.318,5.318,0,0,1,3.942,2.15,3.4,3.4,0,0,1,.647,2.063A1.224,1.224,0,0,1,20.9,9.2a1.7,1.7,0,0,1-.987.373h-2.25c.006.082.01.166.01.248a3.278,3.278,0,0,1-.148.979h2.491l.05-.008a2.765,2.765,0,0,0,1.753-.777,2.36,2.36,0,0,0,.542-1.463A4.627,4.627,0,0,0,21.506,5.73Z"
                      transform="translate(0.003 0.001)"
                      fill="#fff"
                    />
                  </g>
                  <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M37.217,43.038a3.28,3.28,0,0,0-3.1-.06,5.322,5.322,0,0,0-1.59,1.363l-.013.015.013.015c.761.929.761.929.773.929h.011l.008-.01a3.379,3.379,0,0,1,2.344-1.563,1.8,1.8,0,0,1,0,3.607,1.773,1.773,0,0,1-.666-.127,5.5,5.5,0,0,1-2.07-1.736,13.131,13.131,0,0,0-2.084-2.129c-.1-.073-.194-.14-.29-.2l-.082-.055a2.953,2.953,0,1,0-3.223,4.946,3.294,3.294,0,0,0,3.07.077,5.159,5.159,0,0,0,1.624-1.379l.013-.015-.013-.015c-.761-.929-.761-.929-.773-.929h-.011l-.008.01A3.379,3.379,0,0,1,28.8,47.34a1.8,1.8,0,0,1,0-3.607,1.779,1.779,0,0,1,.666.127,5.148,5.148,0,0,1,1.884,1.511l.315.368a16.025,16.025,0,0,0,1.463,1.573l.019.018a4.92,4.92,0,0,0,.845.655,2.953,2.953,0,1,0,3.221-4.947Z"
                    transform="translate(-21.671 -35.703)"
                    fill="#ffcd05"
                  />
                </g>
              </g>
            </g>
            <path
              id="Path_41"
              data-name="Path 41"
              d="M165.278,4.215c-.326-.019-.624-.011-.889,0-.623.015-.958.013-1.216-.2l-.026-.019a2.082,2.082,0,0,0-1.074-.637,2.323,2.323,0,0,0-1.326.092.576.576,0,0,0-.1.037,3.647,3.647,0,0,0-1.244.855,6.722,6.722,0,0,0-1.624,2.716A7.221,7.221,0,0,1,156.257,9.7q.111-.965.161-2.02V7.628c0-.01,0-.019,0-.027s0-.019,0-.029l0-.032,0-.024c0-.011,0-.023-.008-.032s0-.015-.006-.023-.008-.021-.011-.031l-.01-.024-.013-.027-.014-.026a.158.158,0,0,1-.013-.023l-.018-.027-.015-.019c-.006-.01-.015-.018-.021-.026a.18.18,0,0,0-.016-.018.292.292,0,0,0-.023-.023l-.021-.019a.121.121,0,0,0-.023-.018l-.027-.019-.013-.01-.006,0a.208.208,0,0,0-.032-.018.238.238,0,0,0-.021-.011l-.031-.015-.024-.01-.027-.01-.031-.01-.023,0a.273.273,0,0,0-.035-.006l-.021,0a.314.314,0,0,0-.039,0h-.06l-.026,0-.031,0-.029,0-.026,0-.031.008a.141.141,0,0,0-.024.008.236.236,0,0,0-.031.011l-.024.01c-.01,0-.019.008-.027.013l-.024.013-.024.015-.024.016-.023.016-.023.019-.021.019-.019.019-.023.024-.015.018a.233.233,0,0,0-.023.032.042.042,0,0,1-.008.01c-1.042,1.607-2.4,2.532-3.368,2.3a1.855,1.855,0,0,1-1.171-.944,4.956,4.956,0,0,1-.11-3.839c.755-2.307,2.645-3.96,4.131-3.61a1.828,1.828,0,0,1,1.408,1.49,1.1,1.1,0,0,1,.045.232,3.764,3.764,0,0,1-.6.023c-.079,0-.16,0-.239,0a.6.6,0,1,0,0,1.194l.221,0a1.816,1.816,0,0,0,1.587-.473,1.479,1.479,0,0,0,.134-1.3A3,3,0,0,0,155.085.076c-2.134-.5-4.567,1.429-5.538,4.4a6.151,6.151,0,0,0,.2,4.794,3,3,0,0,0,1.937,1.521,2.5,2.5,0,0,0,.581.066,3.6,3.6,0,0,0,2.011-.7,6.346,6.346,0,0,0,.8-.658c-.05.436-.108.857-.176,1.26-4.141,2.718-4.613,4.57-4.523,5.439a1.412,1.412,0,0,0,.915,1.221,1.659,1.659,0,0,0,.6.106,2.607,2.607,0,0,0,1.705-.737c1.086-.989,1.91-2.85,2.389-5.315a6.824,6.824,0,0,0,2.129-2.278,2.884,2.884,0,0,0,.223.508,2.141,2.141,0,0,0,1.9,1.158c1.368,0,2.789-1.257,3.387-3.089a4.8,4.8,0,0,0,.187-2.368c.077,0,.156,0,.234,0,.123,0,.247,0,.369-.006.253-.006.515-.013.79,0a.6.6,0,0,0,.629-.561A.606.606,0,0,0,165.278,4.215ZM152.794,15.9a1.2,1.2,0,0,1-1.076.4c-.066-.026-.135-.073-.153-.231-.015-.137,0-.657.739-1.574a12.047,12.047,0,0,1,2.233-2.036A7.265,7.265,0,0,1,152.794,15.9Zm9.7-8.5c-.513,1.569-1.7,2.426-2.478,2.241a1,1,0,0,1-.64-.523,3.107,3.107,0,0,1-.056-2.365,4.108,4.108,0,0,1,.89-1.544,4.3,4.3,0,0,1,.919-.639,1.318,1.318,0,0,1,.448-.085.972.972,0,0,1,.219.024,1,1,0,0,1,.64.523A3.117,3.117,0,0,1,162.5,7.4Z"
              transform="translate(-121.104 0.004)"
              fill="#fff"
            />
          </g>
        </g>
      </svg>
      <span className={css.hintText}>
        <FormattedMessage id="DrivelahGO.hintText" />
      </span>
    </span>
  );
};

const SuperHostLogo = () => {
  return (
    <span className={css.superHost}>
      <FormattedMessage id="ListingCard.superhost" />
    </span>
  );
};

const FlexLogo = ({ className }) => (
  <img src={flexCarLogo} width={68} height={32} className={className} />
);

const InstantBookingMark = () => {
  return (
    <span className={css.instantBooking}>
      <FormattedMessage id="ListingCard.instant" />
    </span>
  );
};

const LONG_NAME_LENGTH = 30;

const priceData = (price, intl, perMonthPrice, listing, pageName) => {
  if (price && price.currency === config.currency) {
    let priceMaybe = perMonthPrice ? getListingMonthlyPrice(listing) : price;
    if(pageName && pageName === 'LongTermFlex') {
      priceMaybe = getListingMonthlyFlexPrice(listing);
    }
    const formattedPrice = formatMoney(intl, priceMaybe);
    return { formattedPrice, priceTitle: formattedPrice };
  } else if (price) {
    return {
      formattedPrice: intl.formatMessage(
        { id: 'ListingCard.unsupportedPrice' },
        { currency: price.currency }
      ),
      priceTitle: intl.formatMessage(
        { id: 'ListingCard.unsupportedPriceTitle' },
        { currency: price.currency }
      ),
    };
  }
  return {};
};

const ScrollingListingTitle = ({ title, rootClassName, className, titleClassName }) => {
  const classes = classNames(rootClassName || css.longTextWrapper, className);
  const titleClasses = classNames(
    {
      [css.longText]: title.length >= LONG_NAME_LENGTH,
    },
    titleClassName
  );

  return (
    <div className={classes}>
      <span className={titleClasses}>{title}</span>
    </div>
  );
};

const ListingImage = memo(
  props => <ResponsiveImage {...props} />,
  (prev, next) => isEqual(prev, next)
);

const LazyImage = lazyLoadWithDimensions(ListingImage, { loadAfterInitialRendering: 3000 });

const FIELDS = ['listing', 'carListingType', 'hideFlexLabel'];

const ListingCardV2 = memo(
  ({
    carListingType = 'daily',
    listing,
    className,
    rootClassName,
    renderSizes,
    intl,
    setActiveListing,
    perMonthPrice,
    hideFlexLabel,
    pageName
  }) => {
    const ensuredListing = ensureListing(listing);
    const { title, price, publicData = {}, metadata = {} } = ensuredListing.attributes;
    const { isDrivelahGo, reviews = {} } = metadata;
    const { averageRating: averageReview = 'N/A' } = reviews;
    const { instantBooking, numberTripDone = 0, isSuperHost = false } = publicData;
    const isLongTerm = listingIsLongTermRental(listing);
    const classes = classNames(rootClassName || css.root, className);
    const image = Array.isArray(listing.images) ? listing.images[0] : null;
    const { formattedPrice } = priceData(price, intl, perMonthPrice, listing, pageName);
    const id = ensuredListing.id.uuid;
    const slug = createSlug(title);

    let unitTranslationKey;
    let { formattedHourlyPrice } = priceData(price, intl, listing, pageName);
    let diffHours = 9;
    if (diffHours < 12) {
      formattedHourlyPrice = formatHourlyMoney(intl, price, diffHours);
      unitTranslationKey = 'ListingPage.perHour';
    }

    return (
      <NamedLink
        className={classes}
        params={{ id, slug }}
        name={ pageName && pageName === 'LongTermFlex' ? 'LongTermRentalListingPage' : isDrivelahGo ? 'ListingPageGo' : 'ListingPage'}
        // to={{ search: '?pub_longTermRental=true' }}
      >
        <div
          className={css.threeToTwoWrapper}
          onMouseEnter={() => {
            if (typeof setActiveListing === 'function') {
              setActiveListing(ensuredListing.id);
            }
          }}
          onMouseLeave={() => {
            if (typeof setActiveListing === 'function') {
              setActiveListing(null);
            }
          }}
        >
          {isLongTerm && !hideFlexLabel ? <FlexLogo className={css.flexLogo} /> : ''}

          <div className={css.listingImgWrapper}>
            <LazyImage
              rootClassName={css.rootForImage}
              alt={title}
              image={image}
              variants={['landscape-crop', 'landscape-crop2x']}
              sizes={renderSizes}
            />
          </div>
        </div>
        <div className={css.infos}>
          <div className={css.leftInfos}>
            <ScrollingListingTitle
              title={title}
              className={css.titleWrapper}
              titleClassName={css.listingTitle}
            />

            { !(pageName && pageName === 'LongTermFlex') && (isDrivelahGo || instantBooking || isSuperHost) ? (
              <div className={css.logos}>
                <div className={css.logoWrapper}>
                  {isSuperHost ? <SuperHostLogo /> : null}
                  {isDrivelahGo ? (
                    <span className={css.drivelahGoLogo}>
                      <DrivelahGoLogo />
                    </span>
                  ) : null}
                  {instantBooking && !isLongTerm ? <InstantBookingMark /> : null}
                </div>
              </div>
            ) : null}
            {carListingType === 'daily' ? (
              <div className={css.price}>
                <FormattedMessage
                  id={
                    perMonthPrice
                      ? 'ListingCardV2.listingPricePerMonth'
                      : 'ListingCardV2.listingPrice'
                  }
                  values={{ price: <span className={css.highlightPrice}>{formattedPrice}</span> }}
                />
              </div>
            ) : (
              <div className={css.price}>
                <FormattedMessage
                  id={'ListingCard.price'}
                  values={{
                    price: <span className={css.highlightPrice}>{formattedHourlyPrice}</span>,
                    unit: <FormattedMessage id={unitTranslationKey} />,
                  }}
                />
              </div>
            )}
          </div>
          { !(pageName && pageName === 'LongTermFlex') ?  <div className={css.rightInfos}>
            {averageReview !== 'N/A' && averageReview ? (
              <div className={css.ratingWrapper}>
                <IconReviewStar className={css.star} isFilled={true} />
                <span className={css.rating}>{averageReview}</span>
              </div>
            ) : null}
            {numberTripDone > 0 ? (
              <div className={css.doneTrips}>
                <FormattedMessage
                  id="ListingCardv2.doneTrips"
                  values={{ doneTrips: numberTripDone }}
                />
              </div>
            ) : null}
          </div> : ''}

        </div>
      </NamedLink>
    );
  },
  (prev, next) => isEqual(pick(prev, FIELDS), pick(next, FIELDS))
);

export default injectIntl(ListingCardV2);
